import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      notes="Terminal demonstration"
      visualizer="full"
      autoNext={20000}
      terminal={{
        phases: [
          {
            type: 'command',
            content: 'sudo ./breach.sh --target CM.com/ticketing',
          },
          {
            type: 'matrix',
            content: 'BYPASSING SECURITY PROTOCOLS...',
          },
          {
            type: 'access',
            content: 'DATABASE ACCESS ESTABLISHED',
          },
          {
            type: 'command',
            content: 'SELECT * FROM events WHERE name LIKE "%Data Day 7%"',
          },
          {
            type: 'table',
            content: '',
            header: ['ID', 'NAME', 'TICKET_STATUS', 'ROLE'],
            data: [
              ['CM-001', 'Maarten V******', 'CONFIRMED', 'MANAGING DIRECTOR'],
              ['CM-002', 'Lars v** d** V****', 'CONFIRMED', 'SENIOR BUSINESS MANAGER'],
              ['CM-003', 'Bas d* B******', 'CONFIRMED', 'ACCOUNT MANAGER'],
              ['CM-004', 'Jeroen v** G******', 'CONFIRMED', 'PROCESS & BI MANAGER'],
            ],
          },
          {
            type: 'command',
            content: './osint.py --deep-scan --targets "list.txt"',
          },
          {
            type: 'table',
            content: '',
            header: ['TARGET', 'LINKEDIN', 'OTHER', 'EXPERTISE'],
            data: [
              [
                'M.V******',
                'Managing Director @Maunt',
                '20+ years experience',
                'Telecom & Data Infrastructure',
              ],
              [
                'L.V****',
                'Senior Business Manager @Maunt',
                'Strategic mastermind',
                'Telecom & Datacenter sales',
              ],
              ['B.B******', 'Account Manager @Maunt', 'Rising star', 'Telecom & Contracting'],
              ['J.G******', 'Process & BI Manager @Maunt', 'Data wizard', 'Business Intelligence'],
            ],
          },
          {
            type: 'command',
            content: './breach_exchange.sh --silent',
          },
          {
            type: 'matrix',
            content: 'ACCESSING CALENDAR SYSTEMS...',
          },
          {
            type: 'warning',
            content: '[!] INTRUSION DETECTION SYSTEM TRIGGERED',
          },
          {
            type: 'command',
            content: './cleanup.sh --secure-wipe --leave-no-trace',
          },
          {
            type: 'access',
            content: 'OPERATION COMPLETED - ALL TRACES ELIMINATED',
          },
        ],
        config: {
          typingSpeed: 20,
          phaseDelay: 300,
        },
      }}
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
